<template>
  <div>
    <div class="relative">
      <el-tooltip
        class="item"
        effect="dark"
        :content="
          isClusteringEnabled
            ? $t('disable_clustering')
            : $t('enable_clustering')
        "
        placement="bottom"
      >
        <div
          class="
            absolute
            z-50
            bg-white
            cluster-container
            flex
            items-center
            justify-center
            cursor-pointer
          "
          @click="toggleClustering"
        >
          <svg
            class="w-4"
            viewBox="0 0 16 16"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <path
              :fill="isClusteringEnabled ? '#ff5604' : '#000'"
              d="M14 12c-0.372 0.011-0.716 0.121-1.008 0.305l-2.212-2.155c0.434-0.547 0.708-1.239 0.74-1.993l1.57-0.157c0.225 0.556 0.76 0.941 1.385 0.941 0.823 0 1.49-0.667 1.49-1.49s-0.667-1.49-1.49-1.49c-0.749 0-1.368 0.552-1.474 1.271l-1.591 0.128c-0.224-1.136-0.973-2.060-1.978-2.521l0.308-0.839h0.26c1.099-0.008 1.986-0.9 1.986-2 0-1.105-0.895-2-2-2s-2 0.895-2 2c0 0.742 0.404 1.39 1.004 1.735l-0.27 0.855c-0.227-0.054-0.487-0.084-0.754-0.084-0.83 0-1.59 0.296-2.181 0.789l-2.994-3.004c0.141-0.224 0.225-0.497 0.225-0.79 0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5c0 0.823 0.663 1.492 1.484 1.5 0.281-0.001 0.544-0.079 0.767-0.214l2.993 3.004c-0.474 0.588-0.76 1.344-0.76 2.168 0 0.015 0 0.030 0 0.045-0 0.058-0 0.108-0 0.158l-0.66 0.11c-0.313-0.72-1.019-1.214-1.839-1.214-1.105 0-2 0.895-2 2s0.895 2 2 2c1.105 0 2-0.895 2-2 0-0.020-0-0.039-0.001-0.059l0.63-0.097c0.242 0.843 0.768 1.538 1.466 1.992l-0.556 1.188c-0.161-0.049-0.347-0.078-0.539-0.080-0.006-0-0.012-0-0.017-0-1.105 0-2 0.895-2 2s0.895 2 2 2c1.105 0 2-0.895 2-2 0-0.64-0.301-1.211-0.769-1.577l0.566-1.153c0.364 0.146 0.787 0.231 1.229 0.231 0.847 0 1.621-0.311 2.216-0.824l2.176 2.124c-0.25 0.33-0.4 0.748-0.4 1.2 0 1.105 0.895 2 2 2s2-0.895 2-2c0-1.105-0.895-2-2-2 0 0 0 0 0 0zM5 15c-0.552 0-1-0.448-1-1s0.448-1 1-1c0.552 0 1 0.448 1 1s-0.448 1-1 1zM8 10.5c-1.381 0-2.5-1.119-2.5-2.5s1.119-2.5 2.5-2.5c1.381 0 2.5 1.119 2.5 2.5s-1.119 2.5-2.5 2.5z"
            ></path>
          </svg>
        </div>
      </el-tooltip>

      <!-- <el-switch
        v-model="enableClustering"
        active-text="Clustering On"
        inactive-text="Clustering Off"
      ></el-switch> -->

      <HintLabels
        :labels="chartPoints"
        :colors="colors"
        class="
          lg:absolute
          bg-white
          lg:bottom-0
          lg:left-4
          z-50
          lg:p-2
          rounded-md
          lg:shadow-md
        "
      />
      <div
        v-loading="loading"
        v-loading.fullscreen.lock="fullscreenLoading"
        id="mapid"
      ></div>
    </div>
    <Notice class="mt-8" v-if="oldDataCars.length > 0" :noTitle="false">
      <div
        class="
          flex
          lg:items-center
          justify-between
          lg:flex-row
          flex-col
          items-end
        "
      >
        <div class="cursor-pointer" @click="showDetailOldDataCars">
          <i class="el-icon-warning text-xl text-yellow-800"></i>
          {{ $t('VEHICLES_NOT_UPDATE', { type: oldDataCars.length }) }}
          {{ $t('CLICK_TO_VIEW', { type: '' }) }}
        </div>

        <el-button
          class="!cursor-pointer"
          :loading="isDownloadLoading"
          @click="downloadOldDataCars()"
        >
          {{ $t('DOWNLOAD_REPORT') }}
        </el-button>
      </div>
    </Notice>
  </div>
</template>
<script>
import config from '@/configs/configs.js'
import { mapGetters } from 'vuex'
import { License } from '@/mixins/License'
import { tableMarkup } from '@/mixins/tableMarkup'
import Notice from '@/components/elements/notice'
import { licenseChars } from '@/api/global'
import { DownloadNotUpdated } from '@/api/dashboard'
import HintLabels from '../../components/elements/HintLabels.vue'

export default {
  props: ['res'],
  mixins: [License, tableMarkup],
  data() {
    return {
      chartPoints: [
        this.$t('green_point'),
        this.$t('gray_point'),
        this.$t('orange_point'),
        this.$t('idle_vehcile'),
      ],
      colors: ['#67C23A', 'gray', '#f59e0b', 'darkred'],
      alphaList: [
        {
          char: '',
          code: '',
        },
      ],
      isDownloadLoading: false,
      current_position: false,
      latlong: '',
      last_weather: '',
      setIntervalLocation: '',
      setIntervalWeather: '',
      loading: true,
      map: null,
      fullscreenLoading: false,
      lastImei: null,
      isChanged: false,
      oldDataCars: [],
      enableClustering: true,
      isClusteringEnabled: true,
    }
  },
  methods: {
    showDetailOldDataCars() {
      let thead = [],
        tbody = []
      thead.push('LICENSE_PLATE', 'DEVICE_SIM_NUMBER', 'TIME')
      this.oldDataCars.forEach((el) => {
        tbody.push({
          licence: this.License(el.properties.license_plate, this.alphaList),
          sim_numner: '0' + el.properties.device.sim_number,
          timestamp: el.properties.timestamp
            ? `<div class="flex items-center space-x-1 flex-row-reverse">${new Date(
                el.properties.timestamp
              ).toLocaleDateString(
                'fa-IR'
              )}<span class="text-gray-500 symbol ml-1">|</span><span>${new Date(
                el.properties.timestamp
              ).toLocaleTimeString('fa-IR')}</div> `
            : '-',
        })
      })
      let data = `
          <p>
            ${this.$t('VEHICLES_NOT_UPDATED', {
              type: this.oldDataCars.length,
            })}
          </p>
          
        ${this.tableMarkup(thead, tbody)}
        <div class="px-2 py-4">
          <p class="font-bold">
            ${this.$t('ACCRUE_TO')}
          </p>
            <ul class="list-disc leading-6 pr-6 my-2">
              <li>${this.$t('SIMCARD_CHARGE')}</li>
              <li>${this.$t('SIMCARD_ANTHENA')} </li>
              <li>${this.$t('HARDWARE_CONNECTION')}</li>
              <li>${this.$t('CAR_POWER')}</li>

            </ul>
            <p class="text-gray-500">
              ${this.$t('CARPO_SUPPORT')}
            </p>
        </div>
      `

      this.$alert(data, this.$t('description'), {
        dangerouslyUseHTMLString: true,
        closeOnClickModal: true,
        confirmButtonText: this.$t('OK'),
        customClass: 'oldDataCars purple warning_msg',
      })
    },
    downloadOldDataCars() {
      this.isDownloadLoading = true
      DownloadNotUpdated.api()
        .then((res) => {
          this.isDownloadLoading = false
          if (res) {
            var blob = new Blob([res], { type: 'application/octet-stream' })

            const url = window.URL.createObjectURL(blob)
            const a = document.createElement('a')
            a.style.display = 'none'
            a.href = url
            a.download = `vehicles-not-updated-CARPO.xlsx`
            document.body.appendChild(a)
            a.click()

            window.URL.revokeObjectURL(url)
          }
        })
        .catch((error) => {
          this.isDownloadLoading = false
          console.error('Download Error:', error)
        })
    },
    onEachFeature(feature, layer) {
      if (feature.properties) {
        let property = feature.properties

        let popupContent = `
          ${this.popupDetail(
            this.$i18n.t('SPEED') + ':',
            `<span class="mr-1">${property.speed}</span><span class="text-gray-500 symbol">km/h</span> `
          )}
          
            
          ${this.popupDetail(
            this.$i18n.t('DRIVER_TITLE') + ':',
            property.driver != null && property.driver.first_name != null
              ? property.driver.first_name + ' ' + property.driver.last_name
              : ''
          )}

          
          ${this.popupDetail(
            this.$i18n.t('LICENSE_PLATE') + ':',
            this.License(property.license_plate, this.alphaList)
          )}

        ${this.popupDetail(
          this.$i18n.t('temperature') + ':',
          property.temperature === 250.0
            ? this.$i18n.t('ignition_null')
            : property.is_cold_chain
            ? property.temperature + '°C'
            : '',
          'ltr'
        )}

        ${this.popupDetail(
          this.$i18n.t('fuel') + ':',
          property.fuel != null ? property.fuel + ' ' + this.$i18n.t('L') : ''
        )}

        ${this.popupDetail(
          this.$i18n.t('humidity') + ':',
          property.humidity != null ? property.humidity + '%' : ''
        )}
          
       ${this.popupDetail(
         this.$i18n.t('ignition_status') + ':',
         property.ignition === null
           ? this.$i18n.t('ignition_null')
           : property.ignition === 0
           ? `<span class='text-red-700'>${this.$i18n.t(
               'ignition_false'
             )}<span>`
           : `<span class='text-green-700'>${this.$i18n.t(
               'ignition_true'
             )}</span>`
       )}
       
        
        


          ${this.popupDetail(
            this.$i18n.t('DEVICE_SIM_NUMBER') + ':',
            +'0' + property.device.sim_number
          )}

          ${this.popupDetail(
            this.$i18n.t('TAG') + ':',
            property.company_vehicle_tags &&
              property.company_vehicle_tags.length
              ? property.company_vehicle_tags
                  .map((tag) => tag.fa_title)
                  .join(', ')
              : ''
          )}
          
        

          
          ${this.popupDetail(
            this.$i18n.t('TIME') + ':',
            `<div class="flex items-center space-x-1 flex-row-reverse	">${new Date(
              property.timestamp
            ).toLocaleDateString(
              'fa-IR'
            )}<span class="text-gray-500 symbol ml-1">|</span><span>${new Date(
              property.timestamp
            ).toLocaleTimeString('fa-IR')}</span></div> `
          )}

          <div class="py-1 flex flex-col-reverse items-center gap-1 justify-center"><a style="color: darkblue" target="_blank" href="https://www.google.com/maps/dir/?api=1&origin=&destination=${
            feature.geometry.coordinates[1]
          },${feature.geometry.coordinates[0]}">${this.$i18n.t('ROUTING')}</a>

          </div>`

        layer.bindPopup(
          `<div class="divide-y divide-gray-200 text-right leading-6	">
          ${popupContent}
        </div>`,
          { minWidth: 180 }
        )
      }
    },
    generatePulsatingMarker(radius, color, pin = 'pin') {
      const cssStyle = `
        width: ${radius}px;
        height: ${radius}px;
        background: ${color};
        color: ${color};
        box-shadow: 0 0 0 ${color};
      `
      return L.divIcon({
        html: `<span style="${cssStyle}" class="pulse"><img src="../../${pin}.png"></span>`,
        className: '',
      })
    },
    async onLocationFound(map) {
      try {
        const res = await this.$store.dispatch(
          'liveTracking',
          this.combinedSelected
        )

        this.fullscreenLoading = false

        if (res) {
          const datas = [...res]
          this.latlong = datas[0].geometry.coordinates
          if (this.current_position) {
            this.clearMap(map)
          }

          // Initialize the cluster group conditionally
          if (this.isClusteringEnabled) {
            this.current_position = L.markerClusterGroup()
          } else {
            this.current_position = L.layerGroup()
          }

          if (!this.isChanged) {
            this.isChanged = true
          }

          let this_ = this

          for (const element of datas) {
            if (element && element.properties.traffic_status === 'offline') {
              this.oldDataCars.push(element)
            }
            if (this.isChanged && element.geometry.coordinates[1]) {
              const marker = L.marker(
                [
                  element.geometry.coordinates[1],
                  element.geometry.coordinates[0],
                ],
                {
                  icon: this.generatePulsatingMarker(
                    10,
                    this.pulseColorGenerator(element),
                    element.properties.is_cold_chain ? 'snow-pin' : 'pin'
                  ),
                }
              )

              this.current_position.addLayer(marker)

              // Call onEachFeature method for each marker
              this_.onEachFeature(element, marker)
            }
          }

          map.addLayer(this.current_position)
        } else {
          this.$notify.info({
            title: this.$t('NO_RESULT'),
            duration: 5000,
            customClass: 'info_msg',
          })
          clearInterval(this.setIntervalLocation)
        }
      } catch (error) {
        this.fullscreenLoading = false
        console.error('Error in onLocationFound:', error)
      }
    },

    pulseColorGenerator(feature) {
      switch (feature.properties.traffic_status) {
        case 'offline':
          return '#f59e0b' //orange
        case 'moving':
          return '#67C23A' //green
        case 'idle':
          return 'darkred'
        case 'stopped':
          return 'grey'
      }
    },
    HoursDiff(element) {
      let nowTimestamp = new Date().valueOf()
      let diff = nowTimestamp - element.properties.timestamp

      return diff / 1000 / 60 / 60
    },
    popupDetail(title, content, spanClass) {
      return content != null && content != ''
        ? `<div class="py-1 flex justify-between items-center"> <span>${title} </span> <div class="flex items-center space-x-1 flex-row-reverse	"><span class="${spanClass}">${content}</span> </div></div>`
        : ''
    },
    clearMap(map) {
      if (this.current_position) {
        map.removeLayer(this.current_position)
        this.current_position = null
        this.oldDataCars = []
        this.isChanged = false
      }
    },
    handleVisibility() {
      if (document.visibilityState === 'hidden') {
        clearInterval(this.setIntervalLocation)
      } else {
        this.onLocationFound(this.map)
        this.setIntervalLocation = setInterval(() => {
          this.onLocationFound(this.map)
        }, 10000)
      }
    },
    toggleClustering() {
      this.isClusteringEnabled = !this.isClusteringEnabled
    },
  },
  destroyed() {
    clearInterval(this.setIntervalLocation)
    document.removeEventListener(
      'visibilitychange',
      this.handleVisibility,
      true
    )
  },
  beforeDestroy() {
    clearInterval(this.setIntervalLocation)
  },
  computed: {
    ...mapGetters([
      'selectedVehicle',
      'selectedTags',
      'selectedStatus',
      'selectedVehicleName',
      'combinedSelected',
    ]),
  },
  watch: {
    combinedSelected: {
      handler(newVal, oldVal) {
        // Only refresh if map is initialized
        if (!this.map) return

        // Always refresh map when any filter changes (including clears)
        this.clearMap(this.map)
        clearInterval(this.setIntervalLocation)
        this.fullscreenLoading = true
        this.onLocationFound(this.map)
        this.setIntervalLocation = setInterval(() => {
          this.onLocationFound(this.map)
        }, 10000)
      },
      deep: true,
      immediate: true,
    },
    isClusteringEnabled(val) {
      // Watcher to re-fetch data when clustering is toggled
      this.clearMap(this.map)
      clearInterval(this.setIntervalLocation)
      this.fullscreenLoading = true
      this.onLocationFound(this.map)
      this.setIntervalLocation = setInterval(() => {
        this.onLocationFound(this.map)
      }, 10000)
    },
  },

  components: {
    Notice,
    HintLabels,
  },
  mounted() {
    licenseChars.api().then((res) => {
      this.alphaList = res
    })

    var map = L.map('mapid', { tap: false }).setView([32.958566, 53.187538], 5)

    L.tileLayer(config.tile, {
      attribution: '@ Carpo',
      id: 'mapbox/streets-v11',
      tileSize: 512,
      zoomOffset: -1,
      accessToken: config.leaflet,
    }).addTo(map)
    this.onLocationFound(map, this.selectedVehicle, this.selectedTags)
    this.setIntervalLocation = setInterval(() => {
      this.onLocationFound(map, this.selectedVehicle, this.selectedTags)
    }, 10000)
    this.map = map
    this.lastImei = this.selectedVehicle

    // document.addEventListener("visibilitychange", this.handleVisibility, false);
  },
}
</script>
